import { FadeIn } from "~/components/FadeIn";
import { ApiKeyTable } from "~/modules/api_keys/components/ApiKeyTable";
import React from "react";
import { UpdateApiKeyFunction } from "~/modules/api_keys/components/ApiKeyUpdater";
import { ApiKey } from "~/modules/api_keys/types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faKey } from "@fortawesome/pro-regular-svg-icons";
import { LoadingSpinner } from "~/components/LoadingSpinner";

// // // //

/**
 * EmptyState
 * Renders empty state for API Keys
 */
function EmptyState() {
    return (
        <div className="border-2 border-dashed rounded p-12 flex flex-col items-center justify-center text-center select-none">
            <div className="size-12 rounded-full bg-muted flex items-center justify-center mb-4">
                <FontAwesomeIcon
                    className="h-6 w-6 text-muted-foreground"
                    icon={faKey}
                />
            </div>

            <h3 className="font-medium text-foreground mb-1">No API Keys</h3>
            <p className="text-sm text-muted-foreground mb-4">
                Create your first API key to start using the RWA.xyz API
            </p>
        </div>
    );
}

// // // //

export function ApiKeyList(props: {
    loading: boolean;
    apiKeys: ApiKey[];
    onUpdateApiKey: UpdateApiKeyFunction;
}) {
    const { loading, apiKeys, onUpdateApiKey } = props;

    return (
        <React.Fragment>
            {/* Render initial loading state */}
            {loading && apiKeys.length === 0 && (
                <FadeIn>
                    <div className="p-12 flex flex-col items-center justify-center select-none">
                        <LoadingSpinner size={24} />
                        <p className="sr-only">Loading API Keys</p>
                    </div>
                </FadeIn>
            )}

            {/* Render empty state */}
            {!loading && apiKeys.length === 0 && (
                <FadeIn>
                    <EmptyState />
                </FadeIn>
            )}

            {/* Render ApiKeyTable */}
            {apiKeys.length > 0 && (
                <FadeIn>
                    <ApiKeyTable
                        loading={loading}
                        apiKeys={apiKeys}
                        onUpdateApiKey={onUpdateApiKey}
                    />
                </FadeIn>
            )}
        </React.Fragment>
    );
}
